import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import './assets/dependencies';
import SignoutOidc from './components/pages/signout-oidc';
import SigninOidc from './components/pages/signin-oidc';
import ProtectedRoute from './utils/protectedRoute';
import Login from './components/common/login';
import AppRoutes from './appRoutes';
import Config from './config';

export default class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/signout-oidc" component={SignoutOidc} />
        <Route path="/signin-oidc" component={SigninOidc} />
        {Config.isProd ? (
          <ProtectedRoute path="/" component={AppRoutes} />
        ) : (
          <Route path="/" component={AppRoutes} />
        )}
      </Switch>
    );
  }
}
